<template>
  <b-form-select
    v-if="$attrs.type === 'select'"
    v-bind="$attrs"
    v-on="$listeners"
    @change="(e) => on_change(e, 'change')"
  ></b-form-select>
  <b-input v-else v-bind="$attrs" v-on="$listeners" @input="(e) => on_change(e, 'input')" />
</template>

<script>
import { build_store_key, get_stored_value, set_stored_value } from '@/utilities/persistent-inputs';

const DEBOUNCE_TIMEOUT = 300;

export default {
  name: 'persistent-input',
  data() {
    return {
      save_state_timeout: 0,
    };
  },
  created() {
    const value = this.get_value();
    if (this.$attrs.value) {
      this.set_value(this.$attrs.value);
    } else if (value) {
      if (this.$attrs.type === 'select') {
        this.on_change(value, 'change');
      } else {
        this.on_change(value, 'input');
      }
    }
  },
  methods: {
    build_store_key,
    get_stored_value,
    set_stored_value,
    get_key() {
      if (this.$attrs.id) {
        return this.build_store_key(this.$route.name, this.$attrs.id);
      }
      return undefined;
    },
    get_value() {
      return this.get_stored_value(this.get_key());
    },
    set_value(v) {
      return this.set_stored_value(this.get_key(), v);
    },
    on_change(e, method) {
      if (this.$listeners[method]) {
        this.$listeners[method](e);
      }

      if (this.save_state_timeout) {
        clearTimeout(this.save_state_timeout);
      }
      this.save_state_timeout = setTimeout(() => this.set_value(e), DEBOUNCE_TIMEOUT);
    },
  },
};
</script>

<style lang="scss" scoped></style>
